String.prototype['onlyNumbers'] = function (): string {
  return this ? this.replace(/\D/g, '') : this;
};
